import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import { IFormProps } from "types/form-props";
import RHFTextValue from "components/minimal/hook-form/rhf-text-value";
import { fDate } from "utils/format-time";
import RHFRadioGroup from "components/minimal/hook-form/rhf-radio-group";
import { useState } from "react";
import PreviewMedia from "components/common/preview-media/preview-media";
import { RADIO_Status_OPTIONS } from "./challenge-user-report-column";

interface ChallengeUserReportFormProps extends IFormProps {}

const ChallengeUserReportForm: React.FC<ChallengeUserReportFormProps> = ({
  currentItem,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleForm = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Grid item xs={12}>
        <Card>
          <CardHeader title="Challenge Report Information" />
          <Divider />
          <CardContent>
            <RHFTextValue label="User" value={currentItem?.user?.fullName} />

            <RHFTextValue
              label="User Type"
              value={currentItem?.user?.userType?.label}
            />

            {currentItem?.user?.blocked && currentItem?.user?.isActive && (
              <p style={{ color: "red", fontWeight: "bold" }}>
                Reporter isBlocked
              </p>
            )}
            {!currentItem?.user?.isActive && (
              <p style={{ color: "red", fontWeight: "bold" }}>
                Reporter isDeleted
              </p>
            )}

            <RHFTextValue
              label="Challenge Status"
              value={
                currentItem?.challengeUser?.deletedAt ? "Deleted" : "UnDeleted"
              }
            />

            <RHFTextValue
              label="Reporter User"
              value={currentItem?.challengeUser?.user?.fullName}
            />
            <RHFTextValue
              label="Reporter Type"
              value={currentItem?.reporterType}
            />
            <RHFTextValue
              label="Report Date"
              value={fDate(currentItem?.challengeUser?.createdAt)}
            />
            <RHFTextValue
              label="Last Updated Challenge"
              value={fDate(currentItem?.createdAt)}
            />
            <RHFTextValue label="Reason" value={currentItem?.reason} />
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12}>
        <RHFTextValue
          label="Media Link"
          value={
            <Typography
              sx={{ textDecoration: "underline", cursor: "pointer" }}
              fontWeight={500}
              onClick={toggleForm}
            >
              Preview
            </Typography>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <RHFRadioGroup
          label="Status"
          name="status"
          options={RADIO_Status_OPTIONS()}
          sx={{ display: "flex", flexDirection: "row" }}
          disabled={currentItem?.status === "APPROVED"}
        />
      </Grid>
      <PreviewMedia
        urlMedia={currentItem?.challengeUser?.mediaUrl}
        mediaType={currentItem?.challengeUser?.type?.label}
        isOpen={isOpen}
        toggleForm={toggleForm}
      />
    </>
  );
};

export default ChallengeUserReportForm;
